<template>
  <div class="user-group">

    <h4>{{group.role | getGroupTitle}}</h4>
    <ul v-if="group.users.length > 0">
      <li
        v-for="user in group.users"
        :key="user.id"
      >
        <router-link
          :to="{name: 'user_info', params: {userId: user.id}}"
        >
          {{user | getUserFullName}}
        </router-link>
      </li>
    </ul>

    <p v-if="group.users.length === 0">
      {{getEmptyText}}
    </p>

  </div>
</template>

<script>
import { ROLE_ADMIN     } from '../util';
import { ROLE_MODERATOR } from '../util';
import { ROLE_READER    } from '../util';

export default {
  name: 'UsersGroup',

  props: {
    group: {
      type: Object,
      required: true,
    }
  },

  computed: {
    getEmptyText() {
      const role = this.group.role;
      switch(role) {
        case ROLE_ADMIN:     return 'No administrators';
        case ROLE_MODERATOR: return 'No moderators';
        case ROLE_READER:    return 'No readers';
      }
      return `Unknown role code ${role}.`;
    },
  },

  filters: {
    getGroupTitle(role) {
      switch(role) {
        case ROLE_ADMIN:     return 'Administrators';
        case ROLE_MODERATOR: return 'Moderators';
        case ROLE_READER:    return 'Readers';
      }
      return `Unknown role code ${role}.`;
    },
  },
};
</script>
